export default "__VITE_ASSET__BTMh92XX__"